<div class="h-screen w-screen bg-gradient-to-b from-green-300 to-green-700">
    <router-outlet></router-outlet>
</div>
